import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, AppProvider, useAuth } from './components/AppContext'
import Sidebar       from './components/Sidebar'
import Landing       from './pages/Landing'
import Pricing       from './pages/Pricing'
import Login         from './pages/Login'
import Onboarding    from './pages/Onboarding'
import Dashboard     from './pages/Dashboard'
import Categorise    from './pages/Categorise'
import Receipts      from './pages/Receipts'
import Mileage       from './pages/Mileage'
import Timeline      from './pages/Timeline'
import Submit        from './pages/Submit'
import HMRCTax       from './pages/HMRCTax'
import Settings      from './pages/Settings'
import BankConnect   from './pages/BankConnect'
import HMRCCallback  from './pages/HMRCCallback'
import { BlogIndexPage, BlogArticlePage } from './pages/Blog'
import './index.css'

function LoadingScreen() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:14, background:'var(--navy)' }}>
      <div className="spin" style={{ width:24, height:24 }} />
      <div style={{ fontSize:12, color:'var(--slate)' }}>Loading Quarterly...</div>
    </div>
  )
}

function Protected() {
  const { user, profile, loading } = useAuth()

  if (loading) return <LoadingScreen />
  if (!user)   return <Navigate to="/login" replace />

  if (user && (!profile || !profile.onboarded)) {
    return <Navigate to="/onboarding" replace />
  }

  return (
    <AppProvider>
      <div className="shell">
        <Sidebar />
        <main className="main">
          <Routes>
            <Route path="/dashboard"  element={<Dashboard />} />
            <Route path="/connect"    element={<BankConnect />} />
            <Route path="/categorise" element={<Categorise />} />
            <Route path="/receipts"   element={<Receipts />} />
            <Route path="/mileage"    element={<Mileage />} />
            <Route path="/timeline"   element={<Timeline />} />
            <Route path="/submit"     element={<Submit />} />
            <Route path="/hmrc-tax"   element={<HMRCTax />} />
            <Route path="/settings"   element={<Settings />} />
            <Route path="*"           element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </AppProvider>
  )
}

function OnboardingGuard() {
  const { user, profile, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!user)   return <Navigate to="/login" replace />
  if (profile?.onboarded) return <Navigate to="/dashboard" replace />
  return <Onboarding />
}

function RootGuard() {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (user)    return <Navigate to="/dashboard" replace />
  return <Landing />
}

function LoginGuard() {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (user)    return <Navigate to="/onboarding" replace />
  return <Login />
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/"              element={<RootGuard />} />
          <Route path="/login"         element={<LoginGuard />} />
          <Route path="/onboarding"    element={<OnboardingGuard />} />
          <Route path="/pricing"       element={<Pricing />} />
          <Route path="/blog"          element={<BlogIndexPage />} />
          <Route path="/blog/:slug"    element={<BlogArticlePage />} />
          <Route path="/hmrc/callback" element={<HMRCCallback />} />
          <Route path="/app/*"         element={<Protected />} />
          <Route path="/*"             element={<Protected />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
